import React from 'react';
import type { MailListViewBehavior } from '../schema/MailListViewBehavior';
import { MailListViewBehaviorContext } from './MailListViewBehaviorContext';

interface MailListViewBehaviorProviderProps {
    value: MailListViewBehavior;
    children: JSX.Element | JSX.Element[];
}

export const MailListViewBehaviorProvider = (
    props: MailListViewBehaviorProviderProps
): JSX.Element | null => {
    const { value, children } = props;
    return (
        <MailListViewBehaviorContext.Provider value={value}>
            {children}
        </MailListViewBehaviorContext.Provider>
    );
};
